import React, { createContext, useReducer, useContext, useEffect } from "react";
import { refreshAccessToken } from '../../services/authService'
interface AuthState {
  isLoggedIn: boolean;
  initialized: boolean;
}
const initState: AuthState = {
  isLoggedIn: false,
  initialized: false
}

export const AuthContext = createContext<{
  state: AuthState;
  dispatch: (action: dispatchSizeAction) => void;
}>({
  state: initState,
  dispatch: () => {},
});



const ACTION_INIT = "initialize"
const SET_LOGIN   = "set_login"
type authActions = typeof ACTION_INIT |
                   typeof SET_LOGIN;

export type dispatchSizeAction = {
  type: authActions;
  value: any;
};

const authReducer = (
  state: AuthState = initState,
  action: dispatchSizeAction
) => {
  switch (action.type) {
    case SET_LOGIN:
      return { ...state, 
        isLoggedIn: action.value.isLoggedIn, 
        initialized: true
      }
    default:
      return state;
  }
};

export const AuthProvider = ({ children }: any)=>{
  const [state, dispatch] = useReducer(authReducer, initState);
  useEffect(()=> {
    if( state.initialized ) return;
    refreshAccessToken().then( res => {
      console.info( `isLoggedIn = ${( res != null)}`)
      dispatch({
          type: SET_LOGIN,
          value: {
            isLoggedIn: ( res != null),
          }
        });
      }
    )


  })
  return (
    <AuthContext.Provider value={{ state, dispatch }}>
      {state.initialized && children}
    </AuthContext.Provider>
  );
} 

export const useAuth = () => {
  return useContext( AuthContext );
}
